import React from 'react';
import { formatTime } from '../data';

const ResourceTooltip = ({ beforeState, afterState }) => {
  if (!beforeState && !afterState) return null;

  // Use whichever state is available
  const state = beforeState || afterState;
  const { resources: beforeResources, production: beforeProduction } = beforeState || { resources: {}, production: {} };
  const { resources: afterResources, production: afterProduction } = afterState || { resources: {}, production: {} };

  // Helper function to show resource differences
  const showDiff = (before, after) => {
    if (!before || !after) return null;
    const diff = after - before;
    if (diff === 0) return null;
    return (
      <span className={diff > 0 ? "text-green-400" : "text-red-400"}>
        {" "}({diff > 0 ? "+" : ""}{Math.floor(diff)})
      </span>
    );
  };

  return (
    <div className="resource-tooltip bg-gray-800 text-white p-3 rounded-lg shadow-lg border border-gray-600">
      <h3 className="text-lg font-bold mb-2">Resource State</h3>
      
      <div className="mb-3">
        <h4 className="font-semibold text-blue-300">Resources</h4>
        <div className="grid grid-cols-2 gap-2">
          <div className="col-span-1">
            <span className="text-gray-400">Before</span>
          </div>
          <div className="col-span-1">
            <span className="text-gray-400">After</span>
          </div>
          
          <div>
            <span className="text-gray-400">Metal:</span> {Math.round(beforeResources.metal || 0)}
          </div>
          <div>
            <span className="text-gray-400">Metal:</span> {Math.round(afterResources.metal || 0)}
            {showDiff(beforeResources.metal, afterResources.metal)}
          </div>
          
          <div>
            <span className="text-gray-400">Crystal:</span> {Math.round(beforeResources.crystal || 0)}
          </div>
          <div>
            <span className="text-gray-400">Crystal:</span> {Math.round(afterResources.crystal || 0)}
            {showDiff(beforeResources.crystal, afterResources.crystal)}
          </div>
          
          <div>
            <span className="text-gray-400">Deuterium:</span> {Math.round(beforeResources.deuterium || 0)}
          </div>
          <div>
            <span className="text-gray-400">Deuterium:</span> {Math.round(afterResources.deuterium || 0)}
            {showDiff(beforeResources.deuterium, afterResources.deuterium)}
          </div>
        </div>
      </div>
      
      <div>
        <h4 className="font-semibold text-blue-300">Production (per hour)</h4>
        <div className="grid grid-cols-2 gap-2">
          <div className="col-span-1">
            <span className="text-gray-400">Before</span>
          </div>
          <div className="col-span-1">
            <span className="text-gray-400">After</span>
          </div>
          
          <div>
            <span className="text-gray-400">Metal:</span> {Math.round(beforeProduction.metal || 0)}
          </div>
          <div>
            <span className="text-gray-400">Metal:</span> {Math.round(afterProduction.metal || 0)}
            {showDiff(beforeProduction.metal, afterProduction.metal)}
          </div>
          
          <div>
            <span className="text-gray-400">Crystal:</span> {Math.round(beforeProduction.crystal || 0)}
          </div>
          <div>
            <span className="text-gray-400">Crystal:</span> {Math.round(afterProduction.crystal || 0)}
            {showDiff(beforeProduction.crystal, afterProduction.crystal)}
          </div>
          
          <div>
            <span className="text-gray-400">Deuterium:</span> {Math.round(beforeProduction.deuterium || 0)}
          </div>
          <div>
            <span className="text-gray-400">Deuterium:</span> {Math.round(afterProduction.deuterium || 0)}
            {showDiff(beforeProduction.deuterium, afterProduction.deuterium)}
          </div>
          
          <div>
            <span className="text-gray-400">Energy:</span> {Math.round(beforeProduction.energy || 0)}
          </div>
          <div>
            <span className="text-gray-400">Energy:</span> {Math.round(afterProduction.energy || 0)}
            {showDiff(beforeProduction.energy, afterProduction.energy)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResourceTooltip;
